import storeJson from "@/public/ecomsaas-assets/cache/stores.json";


const store = storeJson.length > 0 ? storeJson[0] : null;

/** Logo Functions */
export const getLogo = () => {
  return store
    ? `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${process.env.NEXT_PUBLIC_STORE_CODE}/logos/logowebp.webp`
    : "https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/empty-logowebp.webp";
};

export const getDarkLogo = () => {
  return store
    ? `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${process.env.NEXT_PUBLIC_STORE_CODE}/logos/logowebp.webp`
    : "https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/empty-logowebp.webp";
};

export const getLightLogo = () => {
  return store
    ? `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${process.env.NEXT_PUBLIC_STORE_CODE}/logos/logowebp.webp`
    : "https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/empty-logowebp.webp";
};

export const getMetaTitle = () => {
  return store && store?.title
    ? store?.title
    : store?.store || "EcomSaaS Store";
};

export const getMetaDescription = () => {
  return store && store?.description
    ? store?.description
    : store?.store || "EcomSaaS Store Description";
};

// export const getMetaImageURL = () => {
//   return store && store?.image
//     ? `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${process.env.NEXT_PUBLIC_STORE_CODE}/logos/logowebp.webp`
//     : "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/default/logos/logowebp.webp";
// };
export const getMetaImageURL = () => {
  return `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${process.env.NEXT_PUBLIC_STORE_CODE}/logos/logowebp.webp`;
};


/** Address */
export const getStoreAddress = () => {
  if (store?.address) {
    return store.address.replace(/\n/g, "<br/>");
  }
  return "Your Store Address";
};

/** Contact Info */
export const getSupportMobile = () => {
  return store?.support_mobile || "";
};
export const getCurrencySymbol = () => {
  return store?.currency_symbol || "₹";
};

export const getSupportEmail = () => {
  return store?.support_email || "";
};

/** Legal Entity */
export const getLegalEntity = () => {
  return store?.store || "";
};

export const getStoreName = () => {
  return store?.store || "";
};

/** Store Metadata */
export const getStoreTitle = () => {
  return store?.title || "Your Store Title";
};

export const getBaseUrl = () => {
  return "https://fanboystore.in";
};

export const getStoreDescription = () => {
  return store?.description || "Your Store Description";
};

/** Social Links */
export const getSocialLinks = () => {
  try {
    return store?.social ? JSON.parse(store.social) : [];
  } catch {
    return [];
  }
};

/**
 * Get specific social link by name
 * @param {string} name - e.g. "facebook", "instagram", "twitter", "whatsapp"
 * @returns {string|null} url if found
 */
export const getSocialLinkByName = (name: any) => {
  const socials = getSocialLinks();
  if (!socials.length) return null;

  // normalize both sides (case insensitive)
  const match = socials.find((s: any) =>
    s.name.toLowerCase().includes(name.toLowerCase())
  );

  return match ? match.value : null;
};

/** Region Info */
export const getRegion = () => {
  try {
    return store?.region ? JSON.parse(store.region) || {} : {};
  } catch {
    return {};
  }
};

/** Gateway configs */
export const getGatewayConfig = () => {
  try {
    return store?.gateway_config ? JSON.parse(store.gateway_config) || {} : [];
  } catch {
    return [];
  }
};

/** Marketing configs */
export const getMarketingConfig = () => {
  try {
    return store?.marketing_config
      ? JSON.parse(store.marketing_config) || {}
      : [];
  } catch {
    return [];
  }
};

/** Get Facebook Dataset ID */
export const getFacebookDatasetId = (): string | null => {
  const configs = getMarketingConfig();
  const fbConfig = configs?.find((c: any) =>
    c?.name?.toLowerCase()?.includes("facebook conversion")
  );
  return fbConfig?.datasetid || null;
};

/** Get Google Analytics Measurement ID */
export const getGoogleAnalyticsId = (): string | null => {
  const configs = getMarketingConfig();
  const gaConfig = configs?.find((c: any) =>
    c?.name?.toLowerCase()?.includes("google analytics")
  );
  return gaConfig?.measurement_id || null;
};

/** Partial COD config */
export const getPartialCOD = () => {
  try {
    return store?.partial_cod ? JSON.parse(store?.partial_cod) || {} : {};
  } catch {
    return {};
  }
};

/** Coupons */
export const getCoupons = () => {
  return store?.coupons || [];
};

/** Assets base URL */
export const getAssetsBaseUrl = () => {
  return store?.assets || "";
};
